import { Container } from '@mui/material';
import { Outlet } from 'react-router';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../firebase';
import { RestaurantContextProvider } from '../../providers/RestaurantContextProvider';
import { DietaryContextProvider } from '../../providers/DietaryPreferenceProvider';

const ExplorerLayout = () => {
  const { restaurantId } = useParams();
  const theme = useTheme();
  document.title = 'Explore Restaurant - Goldi';

  useEffect(() => {
    if (restaurantId) {
      logEvent(analytics, 'page_view', {
        page_title: 'Explore Restaurant - Goldi',
        page_location: window.location.href,
        restaurant_id: restaurantId,
      });
    }
  }, [restaurantId]);

  return (
    <RestaurantContextProvider>
      <DietaryContextProvider>
        <Container
          disableGutters
          maxWidth='sm'
          sx={{ backgroundColor: theme.palette.grey[0], height: '100vh' }}
        >
          <Outlet />
        </Container>
      </DietaryContextProvider>
    </RestaurantContextProvider>
  );
};

export default ExplorerLayout;
